import clsx from "clsx";
import { ComponentPropsWithoutRef } from "react";
import { ImageProps, Image } from "../elements/Image";
import { Video, VideoProps } from "../elements/Video";

export type MediaProps = {
  media: {
    image?: ImageProps;
    video?: VideoProps;
  };
} & ComponentPropsWithoutRef<"div">;

export const Media = ({ className, media, ...props }: MediaProps) => {
  return (
    <div style={{ display: "contents" }}>
      {/* Image Only */}
      {media.image && !media.video && (
        <Image className={clsx(className)} {...media.image} id={props.id} />
      )}

      {/* Video Only */}
      {media.video && !media.image && (
        <Video
          className={clsx(className)}
          {...media.video}
          volume={media.video.volume}
          id={props.id}
        />
      )}
      {/* Video + Image Only */}
      {media.video && media.image && (
        <Video
          className={clsx(className)}
          {...media.video}
          poster={media.image.src}
          volume={media.video.volume}
          id={props.id}
        />
      )}
    </div>
  );
};
